import {Component, OnInit, OnDestroy, HostBinding, HostListener, ElementRef} from '@angular/core';

// Services
import {AppService} from '../../shared/services/app-service';
import {NavigationService} from '../../shared/services/navigation-service';
import {GeneratorsService} from '../shared/services/generators-service';
import {CatalogService} from '../shared/services/catalog-service';
import {AppCatalogService} from '../shared/services/app-catalog-service';
import {CartService} from '../shared/services/cart-service';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:SummaryPageCmp'));
let Ps = require('perfect-scrollbar');

@Component({
    selector: 'summary-page-cmp',
    template: require('./summary.cmp.html'),
    styles: [String(require('./summary.cmp.scss'))],
    host: { id: 'summary', class: 'summary-page'}
})

/**
 * Component with access to the state store.
 */
export class SummaryPageCmp {
    
    @HostBinding( 'class.visible' ) _summaryIsVisible: boolean = false;
    @HostBinding( 'class.rendered' ) _summaryIsRendered: boolean = false;
    @HostListener( 'window:resize', ['$event'] ) onResize (event) {
        this._updateCustomScroll();
    }

    // generatorCfg = null;
    // imgPaths = null;
    // roomDimensions = null;
    // UiState = null;
    private _globals = null;
    private _summaryElement = null;
    private _subscriptions:any = {};
    private _imgPaths;


    // TODO: Move all copies to a common service
    private _dic = {
        stone: 'Natural Stone',
        ceramic: 'Ceramic, Porcelain, Glass Tile',
        acrylic: 'Acrylic, Fiberglass, Composite'
    };
    
    constructor(
        // private _uiLayoutService: UiLayoutService,
        // private _cartService: CartService,
        // private _productsService: ProductsService,
        private _appService: AppService,
        private _elementRef: ElementRef,
        private _navigationService: NavigationService,
        private _generatorsService: GeneratorsService,
        private _catalogService: CatalogService,
        private _appCatalogService: AppCatalogService,
        private _cartService: CartService//,
        // private _router: Router
    ) {
        // 'Construct app summary component' );

        this._globals = this._catalogService.getGlobals();

        // console.log('---', this._globals);
        // console.log('---', _generatorsService);
        // var self = this;

        // this.imgPaths = this._productsService.imgPaths;
        // this.roomDimensions = this._cartService.roomDimensions;
        // this.generatorCfg = this._cartService.generatorCfg;
        // this.UiState = this._uiLayoutService.state;

        // Get summary component host element
        this._summaryElement = _elementRef.nativeElement;
        //
        // // Subscribe to events
        // this._subscriptions.previewClosed = _uiLayoutService.events.previewClosed.subscribe(
        //     () => self._openAppSummary()
        // );
        //
        // this._subscriptions.previewOpened = _uiLayoutService.events.previewOpened.subscribe(
        //     () => self._closeAppSummary()
        // );
        //
        // this._subscriptions.fadeOutContent = _uiLayoutService.events.fadeOutContent.subscribe(
        //     () => self._fadeOutAppSummary()
        // );

        this._imgPaths = this._catalogService.imgPaths;
        // console.log( '---', this._imgPaths );
    }

    
    ngOnInit() {
        // 'Initialise app summary component' );

        let self = this;

        // this._uiLayoutService.state.startArrowWasDismised = true;
        // this._uiLayoutService.isAddGenIcnVisible();
        this._openAppSummary();

        // TODO: Improve
        this._subscriptions.previewVisibilityChanged = this._appService.events.previewVisibilityChanged.subscribe( event => {
            event === false ? self._openAppSummary() : self._closeAppSummary();
        });


        this._setupCustomScroll();
    }

    
    ngOnDestroy() {
        // 'Destruct app summary component' );

        for (var subscriptionId in this._subscriptions) {
            this._subscriptions[subscriptionId].unsubscribe();
        }
    }

    
    private _setupCustomScroll () {
        debugOff( 'Setup app summary custom scroll' );
        Ps.initialize( this._summaryElement, {
            minScrollbarLength: 30
        });
    }

    
    private _updateCustomScroll () {
        debugOff( 'Update app summary custom scroll' );
        Ps.update( this._summaryElement );
    }

    
    private _openAppSummary() {
        if (this._summaryIsRendered === true) { return; }
        // 'Open app summary' );
        this._fadeInAppSummary();
        // this._uiLayoutService.state.summaryIsOpened = true;
        // this._uiLayoutService.events.summaryOpened.emit('summaryOpened');
    }

    
    private _closeAppSummary() {
        if (this._summaryIsRendered === false) { return; }
        // 'Close app summary' );
        this._fadeOutAppSummary();
        // this._uiLayoutService.state.summaryIsOpened = false;
        // this._uiLayoutService.events.summaryClosed.emit('summaryClosed');
    }

    
    private _fadeInAppSummary() {
        var self = this;

        debugOff( 'Fade in app summary' );

        this._summaryIsRendered = true;
        setTimeout( () => self._summaryIsVisible = true, 0 );
    }

    
    private _fadeOutAppSummary() {
        var self = this;

        debugOff( 'Fade out app summary' );

        this._summaryIsVisible = false;
        setTimeout(() => self._summaryIsRendered = false, 300);
    }
    
    private _roundRoomVolume(volume) {
        debugOff( 'Round room volume' );
        return Math.ceil(volume);
    }

    setProduct(){
        console.log(23)
        this._cartService.productEvent.emit("")
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/pages/summary.cmp.ts